/**
 * Renders a component that clears sessionStorage and redirects to the home page.
 * @returns ReactElement
 */
import { RouteTypes } from 'consts';
import { ReactElement, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import styles from '../../components/FullScreenLoader/FullScreenLoader.module.scss';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { setProfileSelected, resetCreatePracticeForm } from 'store/app/actions';
import { makeSelectProfileSelected } from 'store/app/selectors';

const ChangeFilter = (): ReactElement => {
  const history = useHistory();
  const location = useLocation<any>();
  const dispatch = useDispatch();

  const profileSelectedInStore = useSelector(makeSelectProfileSelected());

  const requestedIdPerfil = useRef<number | null>(null);
  const redirectIdPerfil = useRef(false);

  useEffect(() => {
    deleteSavedPagination(window.location.pathname, false, true);
    const selectedIdPerfil = location?.state?.selectedIndex;

    if (typeof selectedIdPerfil !== 'number') {
      history.replace(RouteTypes.HOME);
      return;
    }

    requestedIdPerfil.current = selectedIdPerfil;
    dispatch(setProfileSelected(selectedIdPerfil));
    dispatch(resetCreatePracticeForm());

    const timerId = window.setTimeout(() => {
      if (!redirectIdPerfil.current) {
        redirectIdPerfil.current = true;
        history.replace(RouteTypes.HOME);
      }
    }, 500);

    return () => clearTimeout(timerId);

  }, []);

  useEffect(() => {
    if (!redirectIdPerfil.current && requestedIdPerfil.current === profileSelectedInStore) {
      redirectIdPerfil.current = true;
      history.replace(RouteTypes.HOME);
    }
  }, [profileSelectedInStore, history]);

  return (
    <>
      <div className={`${styles.loading} ${styles.loadingShow}`}>
        <div className={styles.loadingIcon}></div>
      </div>
    </>
  );
};

export default ChangeFilter;
